module.exports = __webpack_public_path__ + "img/LOGOwanzou.1606dde0.png";